var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#EA2C14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8645 23.3208H24.0515L23.7633 23.0429C24.7719 21.8696 25.3791 20.3465 25.3791 18.6895C25.3791 14.9949 22.3842 12 18.6895 12C14.9949 12 12 14.9949 12 18.6895C12 22.3842 14.9949 25.3791 18.6895 25.3791C20.3465 25.3791 21.8696 24.7719 23.0429 23.7633L23.3208 24.0515V24.8645L28.4666 30L30 28.4666L24.8645 23.3208ZM18.6895 23.3208C16.1269 23.3208 14.0583 21.2521 14.0583 18.6895C14.0583 16.1269 16.1269 14.0583 18.6895 14.0583C21.2521 14.0583 23.3208 16.1269 23.3208 18.6895C23.3208 21.2521 21.2521 23.3208 18.6895 23.3208Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7772da2eefd3519a0d3efce0fb93c191.svg";
export { ForwardRef as ReactComponent };